import Link, { LinkProps } from 'next/link';
import { HTMLProps } from 'react';

type AProps = { external: true; href: string } | { external?: false };

export function A({
  external,
  href,
  ...props
}: { children?: React.ReactNode } & LinkProps &
  React.RefAttributes<HTMLAnchorElement> &
  AProps &
  HTMLProps<HTMLAnchorElement>) {
  if (external) return <a target="_blank" rel="noopener noreferrer" href={href} {...props}></a>;
  return <Link href={href} {...props}></Link>;
}
